import styled from 'styled-components/macro';
import loaderImage from './images/loader.svg';

export const LoaderContainer = styled.div`
  text-align: center;
  position: relative;
  max-width: 500px;
  margin: auto;
`;

export const LoaderImage = styled.div`
  text-indent: 100%;
  overflow: hidden;
  width: 100%;
  height: 70px;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    margin-left: -35px;
    left: 50%;
    width: 70px;
    height: 70px;
    background: url(${loaderImage}) no-repeat center / 70px;
  }
`;

export const LoaderMessage = styled.p`
  margin: 10px 0 0;
`;